import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    ENVIRONMENTS_QUERY,
    SINGLE_ENVIRONMENT_QUERY,
    CREATE_ENVIRONMENT_MUTATION,
    UPDATE_ENVIRONMENT_MUTATION,
    DELETE_ENVIRONMENT_MUTATION
} from "@/graphql/environments.js";

const state = {
    environments: []
};

const getters = {};

const mutations = {
    [types.SET_ENVIRONMENTS](state, environments) {
        state.environments = environments;
    },
    [types.SORT_ENVIRONMENTS](state) {
        state.environments.sort(function(a, b) {
            return a.node.environment.toLowerCase() == b.node.environment.toLowerCase()
                ? 0
                : a.node.environment.toLowerCase() > b.node.environment.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_ENVIRONMENT](state, environment) {
        var index = state.environments.findIndex(function(element) {
            return element.node.id == environment.id;
        });

        const node = { node: environment };

        if (index > -1) {
            state.environments.splice(index, 1, node);
        } else {
            state.environments.unshift(node);
        }
    },
    [types.DELETE_ENVIRONMENT](state, environment) {
        var index = state.environments.find(function(element, index) {
            if (element.id == environment.id) {
                return index;
            }
        });

        if (index > -1) {
            state.environments.splice(index, 1);
        }
    }
};

const actions = {
    async fetchEnvironments(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ENVIRONMENTS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    const environments = response.data.tenantEnvironments.edges;

                    // set
                    context.commit(
                        types.SET_ENVIRONMENTS,
                        environments
                    );

                    // sort
                    context.commit(types.SORT_ENVIRONMENTS);

                    resolve(environments);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleEnvironment(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_ENVIRONMENT_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const environment = JSON.parse(JSON.stringify(response.data.environment));

                    // update store
                    context.commit(
                        types.UPSERT_ENVIRONMENT,
                        environment
                    );

                    // sort
                    context.commit(types.SORT_ENVIRONMENTS);

                    resolve(environment);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createEnvironment(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_ENVIRONMENT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const environment =
                        response.data.createEnvironment.environment;

                    // update store
                    context.commit(
                        types.UPSERT_ENVIRONMENT,
                        environment
                    );

                    // sort
                    context.commit(types.SORT_ENVIRONMENTS);

                    resolve(environment);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateEnvironment(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_ENVIRONMENT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const environment =
                        response.data.updateEnvironment.environment;

                    // update store
                    context.commit(
                        types.UPSERT_ENVIRONMENT,
                        environment
                    );

                    // sort
                    context.commit(types.SORT_ENVIRONMENTS);

                    resolve(environment);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteEnvironment(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_ENVIRONMENT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const environment =
                        response.data.deleteEnvironment.environment;

                    // update store
                    context.commit(
                        types.DELETE_ENVIRONMENT,
                        environment
                    );

                    resolve(environment);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
